import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/CustomButtonEdit.css';

/**
 * Кастомная кнопка редактирования с иконкой.
 * Предназначена для вызова действия редактирования в таблицах, карточках и т.п.
 *
 * @component
 * @param {Object} props - Свойства компонента.
 * @param {function} props.onClick - Обработчик нажатия на кнопку (обязателен).
 * @param {string} [props.margin] - Внешние отступы кнопки.
 * @param {boolean} [props.disabled] - Флаг для отключения кнопки.
 * @param {string} [props.className] - Дополнительные CSS-классы, добавляемые к базовому стилю кнопки.
 *
 * @returns {JSX.Element} Кнопка с иконкой редактирования.
 */

function CustomButtonEdit({ onClick, margin, disabled, className }) {
  const buttonStyle = {
    margin: margin,
  };
  return (
    <button
      className={'custom-button-edit ' + (className ?? '')}
      style={buttonStyle}
      onClick={onClick}
      disabled={disabled}
    >
      <img src="/image/pen.svg" alt="Edit" className="edit-icon" />
    </button>
  );
}

CustomButtonEdit.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CustomButtonEdit;
